import { GridLayout } from "@arelia-components/layout/GridLayout";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import _, { round, sumBy } from "lodash";
import AvgWatchedTimeList from "./AvgWatchedTimeList";
import { LikesPiechart } from "./LikesPiechart";
import { TotalVideoMetrics } from "./models";
import { SocialActionsPiechart } from "./SocialActionsPiechart";
import { ViewsBarchart } from "./ViewsBarchart";

type Props = {
  data: TotalVideoMetrics[];
  isLoading: boolean;
}

export default function MyVideosPresenter({ data, isLoading }: Props) {
  const initialViewsData = data?.map(({ name, views }) => ({ label: `${name}`, value: views }));
  const viewsData = _(initialViewsData)
    .groupBy('label')
    .map((items, label) => ({
      label: label,
      value: sumBy(items, 'value')
    }))
    .value();

  const totalLikes = data?.reduce((acc, { likes }) => acc + likes, 0) || 1;
  const initialLikesData = data?.map(({ name, likes }) => ({ label: name, value: round((likes / totalLikes) * 100, 2), total: likes}));
  const likesData = _(initialLikesData)
    .groupBy('label')
    .map((items, label) => ({
      label: label,
      value: sumBy(items, 'value'),
      total: sumBy(items, 'total')
    }))
    .value();

  const totalSocialActions = data?.reduce((acc, { socialActions }) => acc + socialActions, 0) || 1;
  const initialSocialActionsData = data?.map(({ name, socialActions }) => ({ label: name, value: round((socialActions / totalSocialActions) * 100, 2), total: socialActions }));
  const socialActionsData = _(initialSocialActionsData)
    .groupBy('label')
    .map((items, label) => ({
      label: label,
      value: sumBy(items, 'value'),
      total: sumBy(items, 'total')
    }))
    .value();

  const initialAvgWatchedTimeData = data?.map(({ name, avgWatchedTime }) => ({ label: name, value: avgWatchedTime }));
  const avgWatchedTimeData = _(initialAvgWatchedTimeData)
    .groupBy('label')
    .map((items, label) => ({
      label: label,
      value: sumBy(items, 'value') / items.length
    }))
    .value();

  return <GridLayout>
    <ViewsBarchart data={viewsData} loading={isLoading} />
    <LikesPiechart data={likesData} loading={isLoading} />
    <SocialActionsPiechart data={socialActionsData} loading={isLoading} />
    <AvgWatchedTimeList data={avgWatchedTimeData} loading={isLoading} />
  </GridLayout>;
}